<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<form [formGroup]="form" novalidate nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" *ngIf="loadInfo">
  <div nz-row [nzGutter]="[16, 16]">
    <div nz-col [nzSpan]="24" class="mb-sm d-flex flex-column justify-content-between">
      <div class="input-label-form">¿Cuál es su ocupación actualmente?</div>
      <textarea [nzAutosize]="{ minRows: 3, maxRows: 3 }" nz-input formControlName="occupation" placeholder="Por ejemplo, programador"></textarea>
    </div>
  </div>

  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mb-7 tw-mt-4">
    <label nz-checkbox formControlName="exercises" class="tw-flex tw-items-center" (ngModelChange)="onChangeDoExercises($event)">
      <div class="tw-flex tw-items-center">
        <img src="./../../../assets/images/icons/icons8-exercise-100.png" class="tw-w-8 tw-mr-2" alt="">
        <p class="text-info">¿Realiza ejercicio o alguna actividad física?</p>
      </div>
    </label>
  </div>

  <div nz-row [nzGutter]="[16, 16]" @fadeInAnimation *ngIf="form.get('exercises')?.value">
    <div nz-col nzXs="24" nzMd="12" nzLg="8"
      class="mb-sm d-flex flex-column">
      <div class="input-label-form">¿Desde hace cuánto tiempo?</div>
      <nz-select formControlName="exerciseTimeSinceStart" nzPlaceHolder="Seleccione la opción">
        <nz-option [nzValue]="exerciseTimeSinceStartEnum.LESS_THAN_MONTH" [nzLabel]="exerciseTimeSinceStartEnum.LESS_THAN_MONTH |
          getTranslateEnum:'exerciseTimeSinceStart'"></nz-option>
        <nz-option [nzValue]="exerciseTimeSinceStartEnum.LESS_THAN_THREE_MONTHS" [nzLabel]="exerciseTimeSinceStartEnum.LESS_THAN_THREE_MONTHS |
          getTranslateEnum:'exerciseTimeSinceStart'"></nz-option>
        <nz-option [nzValue]="exerciseTimeSinceStartEnum.LESS_THAN_ONE_YEAR" [nzLabel]="exerciseTimeSinceStartEnum.LESS_THAN_ONE_YEAR |
          getTranslateEnum:'exerciseTimeSinceStart'"></nz-option>
        <nz-option [nzValue]="exerciseTimeSinceStartEnum.MORE_THAN_ONE_YEAR" [nzLabel]="exerciseTimeSinceStartEnum.MORE_THAN_ONE_YEAR |
          getTranslateEnum:'exerciseTimeSinceStart'"></nz-option>
      </nz-select>
      <app-message-field [field]="form.get('exerciseTimeSinceStart')"></app-message-field>
    </div>
    <div nz-col nzXs="24" nzMd="12" nzLg="8"
      class="mb-sm d-flex flex-column">
      <div class="input-label-form">Nivel de actividad física</div>
      <nz-select formControlName="physicalLevelActivity" nzPlaceHolder="Seleccione la opción">
        <nz-option
          nzCustomContent
          [nzValue]="physicalActivityLevelEnum.NO_ACTIVITY"
          [nzLabel]="physicalActivityLevelEnum.NO_ACTIVITY | getTranslateEnum:'physicalActivityLevel'">
          <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.NO_ACTIVITY | getTranslateEnum:'physicalActivityLevel' }}</p>
          <p class="text-info"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span> dormir o reclinarme</p>
        </nz-option>
        <nz-divider style="margin: 15px 0;"></nz-divider>
        <nz-option
          nzCustomContent
          [nzValue]="physicalActivityLevelEnum.LIGHT_EXERCISE"
          [nzLabel]="physicalActivityLevelEnum.LIGHT_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
          <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.LIGHT_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
          <p class="text-info">1-3 días u horas a la semana</p>
          <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. estar sentada(o) o de pie: ej. pintar, manejar, planchar, cocinar, trabajo de oficina</p>
        </nz-option>
        <nz-divider style="margin: 15px 0;"></nz-divider>
        <nz-option
          nzCustomContent
          [nzValue]="physicalActivityLevelEnum.MODERATE_EXERCISE"
          [nzLabel]="physicalActivityLevelEnum.MODERATE_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
          <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.MODERATE_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
          <p class="text-info">3 a 5 días u horas a la semana</p>
          <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. caminata moderada, elíptica, trotar, golf, trabajar en restaurante, cuidar a niños</p>
        </nz-option>
        <nz-option
          nzCustomContent
          [nzValue]="physicalActivityLevelEnum.HEAVY_EXERCISE"
          [nzLabel]="physicalActivityLevelEnum.HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
          <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
          <p class="text-info">6-7 días u horas a la semana</p>
          <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. ciclismo, esquiar, tennis, ejercicios de resistencia, atletismo, caminata intensa, llevar una carga, etc. Con bastante desgaste</p>
        </nz-option>
        <nz-divider style="margin: 15px 0;"></nz-divider>
        <nz-option
          nzCustomContent
          [nzValue]="physicalActivityLevelEnum.VERY_HEAVY_EXERCISE"
          [nzLabel]="physicalActivityLevelEnum.VERY_HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel'">
          <p class="tw-font-semibold tw-text-gray-700">{{ physicalActivityLevelEnum.VERY_HEAVY_EXERCISE | getTranslateEnum:'physicalActivityLevel' }}</p>
          <p class="text-info">2 veces al día o 4 a 5 horas diarias</p>
          <p class="text-info tw-whitespace-normal"><span class="tw-text-gray-400 tw-font-semibold tw-mr-2">Actividad diaria:</span>Ej. basquetbol, futbol americano, soccer, escalar montañas, entrenamiento militar, boxear, ciclismo, atletismo</p>
        </nz-option>
      </nz-select>
      <app-message-field [field]="form.get('physicalLevelActivity')"></app-message-field>
    </div>
    <div nz-col nzXs="24" nzMd="12" nzLg="8"
      class="mb-sm d-flex flex-column">
      <div class="input-label-form">Del 0 al 10 ¿Cuál es la intensidad del ejercicio?</div>
      <div class="tw-flex tw-items-center">
        <nz-slider formControlName="exerciseIntensity" [nzMin]="0" [nzMax]="10" [nzStep]="1"></nz-slider>
        <p class="tw-text-gray-800 tw-text-sm tw-font-semibold tw-ml-3">{{ form.get('exerciseIntensity').value || 0 }} <span class="tw-text-gray-600
            tw-text-sm">de
            10</span></p>
      </div>
      <app-message-field [field]="form.get('exerciseIntensity')"></app-message-field>
    </div>
  </div>

  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mt-3 tw-w-full" @fadeInAnimation
    *ngIf="form.get('exercises')?.value">
    <div class="text-info tw-mb-0">¿Cuántas horas realiza ejercicio por día?</div>
    <p class="text-info">Ingresa la cantidad de horas que utilizas diariamente a tus ejercicios.</p>
    <div nz-col nzSpan="24" [formGroup]="form.get('exercisePerDay')!">
      <div class="container-days" @fadeInAnimation>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Lunes</p>
          <app-input-number [min]="0" [max]="24" formControlName="monday"></app-input-number>
        </div>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Martes</p>
          <app-input-number [min]="0" [max]="24" formControlName="tuesday"></app-input-number>
        </div>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Miercoles</p>
          <app-input-number [min]="0" [max]="24" formControlName="wednesday"></app-input-number>
        </div>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Jueves</p>
          <app-input-number [min]="0" [max]="24" formControlName="thursday"></app-input-number>
        </div>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Viernes</p>
          <app-input-number [min]="0" [max]="24" formControlName="friday"></app-input-number>
        </div>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Sábado</p>
          <app-input-number [min]="0" [max]="24" formControlName="saturday"></app-input-number>
        </div>
        <div class="tw-flex tw-flex-col tw-items-start">
          <p class="tw-text-gray-700 tw-font-semibold tw-mt-2 tw-mb-2 tw-text-center">Domingo</p>
          <app-input-number [min]="0" [max]="24" formControlName="sunday"></app-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mt-3 tw-w-full" @fadeInAnimation>
    <div class="tw-gray-700 tw-font-semibold tw-mb-3">SEDENTARISMO</div>
    <p class="text-info">¿Cuántas horas al día en promedio pasas sentado por relax o diversión, (suma todas)?</p>
    <p class="tw-text-gray-400 tw-mb-2">
      Ver películas, redes sociales o videojuegos en celular, tableta, computadora, hablar por teléfono sentado, estar tumbado en el sofá, otros juegos sedentarios.
    </p>
    <nz-radio-group nzButtonStyle="solid" formControlName="howManyHoursSpendSittingOrRelaxADay">
      <label nz-radio [nzValue]="0">0 a 2 horas</label>
      <label nz-radio [nzValue]="2">2 a 4 horas</label>
      <label nz-radio [nzValue]="4">más de 4 horas</label>
    </nz-radio-group>
    <p class="text-info tw-mt-5">¿Cuántas horas al día en promedio estás sentado sin pausa de activación por cuestiones de estudio, escuela, trabajo, traslados, (suma todas)?</p>
    <p class="tw-text-gray-400 tw-mb-2">
      Escuela, oficina, investigación, lectura, estudio, viaje en coche, vuelos, etc.
    </p>
    <nz-radio-group nzButtonStyle="solid" formControlName="howManyHoursSpendSittingPerStudySchoolWorkMovingADay">
      <label nz-radio [nzValue]="0">0 a 2 horas</label>
      <label nz-radio [nzValue]="2">2 a 4 horas</label>
      <label nz-radio [nzValue]="4">más de 4 horas</label>
    </nz-radio-group>
    <p class="text-info tw-mt-5 tw-mb-2">¿Sabes cuántos pasos caminas al día?</p>
    <nz-radio-group nzButtonStyle="solid" formControlName="howManyStepsWalkADay">
      <label nz-radio [nzValue]="4">menos de 3,000</label>
      <label nz-radio [nzValue]="1">más de 3,000 pero menos de 5,000</label>
      <label nz-radio [nzValue]="-1">más de 5,000 pero menos de 8,000</label>
      <label nz-radio [nzValue]="-3">hasta 10,000</label>
      <label nz-radio [nzValue]="-4">más de 10,000</label>
      <label nz-radio [nzValue]="0">no los he contado</label>
    </nz-radio-group>
  </div>
</form>

<div class="d-flex justify-content-end" *ngIf="!(this.isPatient$ | async)">
  <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
</div>
